<div class="section">
    <div class="px-3">
        <div class="theme-container">
            <h1 class="section-title">Our Home Delivery Service</h1>
            <p class="section-desc text-muted">This is what we do and we do it perfectly.</p>

            <div fxLayout="row wrap">
                <div fxFlex="100" fxFlex.gt-sm="25" class="py-3">
                    <h1 class="secondary-font primary-color text-center">Main Choice Menu</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse semper lobortis quam, id imperdiet mi feugiat quis. Cras a odio posuere, rhoncus quam vitae, commodo neque. Nunc mollis velit vulputate, volutpat diam vitae, egestas turpis. In posuere tempor lorem, sit amet pulvinar nunc accumsan a. Quisque sem tellus, congue at eleifend sit amet, consectetur sit amet est. Integer sodales quam quis elit commodo consequat. Aenean posuere augue a justo gravida elementum laoreet tincidunt enim. Nullam sagittis mauris id dui scelerisque, eget dignissim est hendrerit. Praesent fringilla commodo egestas. Suspendisse bibendum purus vitae mi mattis laoreet.</p>
                </div>
                <div fxFlex="100" fxFlex.gt-sm="75" class="py-3">
                    <img src="assets/images/homeDelivery1.png" alt="about-2" class="mw-100">
                </div>
            </div>

            <a mat-raised-button routerLink="/home-delivery" color="primary" class="uppercase">Read more about our home delivery service</a>
        </div>
    </div>
</div>